// import React, { memo } from "react";
// import PropTypes from "prop-types";
// // import { Link } from "react-router-dom";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   Hidden,
//   IconButton,
//   withStyles
// } from "@material-ui/core";
// import MenuIcon from "@material-ui/icons/Menu";
// // import HomeIcon from "@material-ui/icons/Home";
// // import HowToRegIcon from "@material-ui/icons/HowToReg";
// // import LockOpenIcon from "@material-ui/icons/LockOpen";
// // import BookIcon from "@material-ui/icons/Book";
// import NavigationDrawer from "../../../shared/components/NavigationDrawer";
// import { fontFamily } from "@material-ui/system";

// const styles = theme => ({
//   appBar: {
//     boxShadow: theme.shadows[6],
//     backgroundColor: theme.palette.common.white
//   },
//   toolbar: {
//     display: "flex",
//     justifyContent: "space-between",
//   },
//   menuButtonText: {
//     fontSize: theme.typography.body1.fontSize,
//     fontWeight: theme.typography.h6.fontWeight
//   },
//   brandText: {
//     fontFamily: "'Playfair Display', serif !important", // Ensures the correct font
//     fontSize: "2.5rem !important", // Increases size
//     color: "#361C10 !important", // Changes color
//     fontWeight: "500", // Makes it bold
//     letterSpacing: "1.1px", // Adjusts spacing slightly
//   },
//   noDecoration: {
//     textDecoration: "none !important"
//   },
//   tryWolfeButton: {
//     backgroundColor: "#361C10", // Black button
//     color: "#FFFFFF", // White text
//     padding: "10px 30px",
//     borderRadius: "100px",
//     textTransform: "none",
//     fontSize: "16px",
//     fontFamily: "'Lato', sans-serif !important", // Ensures the correct font
//     fontWeight: "bold",
//     "&:hover": {
//       backgroundColor: "#4A2A1A" // Slightly lighter black on hover
//     }
//   }
// });

// function NavBar(props) {
//   const {
//     classes,
//     // openRegisterDialog,
//     openLoginDialog,
//     handleMobileDrawerOpen,
//     handleMobileDrawerClose,
//     mobileDrawerOpen,
//     selectedTab
//   } = props;
//   const menuItems = [
//     {
//     //   link: "/",
//     //   name: "Home",
//     //   icon: <HomeIcon className="text-white" />
//     // },
//     // {
//     //   link: "/blog",
//     //   name: "Blog",
//     //   icon: <BookIcon className="text-white" />
//     // },
//     // {
//     //   name: "Register",
//     //   onClick: openRegisterDialog,
//     //   icon: <HowToRegIcon className="text-white" />
//     // },
//     // {
//       name: "Try Wolfe",
//       link: "https://www.hellowolfe.ai"
//       // onClick: openLoginDialog,
//       // icon: <LockOpenIcon className="text-white" />
//     }
//   ];
  
//   return (
//     <div className={classes.root}>
//       <AppBar position="fixed" className={classes.appBar}>
//         <Toolbar className={classes.toolbar}>
//           <div>
//             <Typography
//               variant="h4"
//               className={classes.brandText}
//               display="inline"
//               color="secondary"
//             >
//               Wolfe
//             </Typography>
//           </div>
//           <div>
//             <Hidden mdUp>
//               <IconButton
//                 className={classes.menuButton}
//                 onClick={handleMobileDrawerOpen}
//                 aria-label="Open Navigation"
//               >

// <MenuIcon color="primary" />
//               </IconButton>
//             </Hidden>
//             <Hidden smDown>
//               {menuItems.map(element => {
//                 if (element.link) {
//                   return (
//                     <a
//                       key={element.name}
//                       href={element.link}
//                       className={classes.noDecoration}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                     >
//                       <Button
//                         className={classes.tryWolfeButton}
//                         size="large"
//                       >
//                         {element.name}
//                       </Button>
//                     </a>
//                   );
//                 }
//                 return (
//                   <Button
//                     color="secondary"
//                     size="large"
//                     onClick={element.onClick}
//                     classes={{ text: classes.menuButtonText }}
//                     key={element.name}
//                   >
//                     {element.name}
//                   </Button>
//                 );
//               })}
//             </Hidden>
//           </div>
//         </Toolbar>
//       </AppBar>
//       <NavigationDrawer
//         menuItems={menuItems}
//         anchor="right"
//         open={mobileDrawerOpen}
//         selectedItem={selectedTab}
//         onClose={handleMobileDrawerClose}
//       />
//     </div>
//   );
// }

//                 {/* <MenuIcon color="primary" />
//               </IconButton>
//             </Hidden>
//             <Hidden smDown>
//               {menuItems.map(element => {
//                 if (element.link) {
//                   return (
//                     <Link
//                       key={element.name}
//                       to={element.link}
//                       className={classes.noDecoration}
//                       onClick={handleMobileDrawerClose}
//                     >
//                       <Button
//                         color="secondary"
//                         size="large"
//                         classes={{ text: classes.menuButtonText }}
//                       >
//                         {element.name}
//                       </Button>
//                     </Link>
//                   );
//                 }
//                 return (
//                   <Button
//                     color="secondary"
//                     size="large"
//                     onClick={element.onClick}
//                     classes={{ text: classes.menuButtonText }}
//                     key={element.name}
//                   >
//                     {element.name}
//                   </Button>
//                 );
//               })}
//             </Hidden>
//           </div>
//         </Toolbar>
//       </AppBar>
//       <NavigationDrawer
//         menuItems={menuItems}
//         anchor="right"
//         open={mobileDrawerOpen}
//         selectedItem={selectedTab}
//         onClose={handleMobileDrawerClose}
//       />
//     </div>
//   );
// } */}

// NavBar.propTypes = {
//   classes: PropTypes.object.isRequired,
//   handleMobileDrawerOpen: PropTypes.func,
//   handleMobileDrawerClose: PropTypes.func,
//   mobileDrawerOpen: PropTypes.bool,
//   selectedTab: PropTypes.string,
//   // openRegisterDialog: PropTypes.func.isRequired,
//   // openLoginDialog: PropTypes.func.isRequired
// };

// export default withStyles(styles, { withTheme: true })(memo(NavBar));


//this is a new code below that eliminated the side drawer and the menu icon, 
// and added a button to the right of the nav bar, we can change it back to the above when we need  a list of items on the navbar

import React, { memo } from "react";
import PropTypes from "prop-types";
// If you need react-router for internal navigation, you can keep this import.
// Otherwise, remove it.
// import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  withStyles
} from "@material-ui/core";

// We no longer need IconButton, Hidden, MenuIcon, or NavigationDrawer imports.

const styles = (theme) => ({
  appBar: {
    boxShadow: theme.shadows[6],
    backgroundColor: theme.palette.common.white
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between", // Brand on left, button on right
    alignItems: "center"
  },
  brandText: {
    fontFamily: "'Playfair Display', serif !important", // Custom font
    fontSize: "2.5rem !important",
    color: "#361C10 !important",
    fontWeight: "500",
    letterSpacing: "1.1px",
  },
  noDecoration: {
    textDecoration: "none !important"
  },
  tryWolfeButton: {
    backgroundColor: "#361C10", // Dark brown
    color: "#FFFFFF",           // White text
    padding: "10px 30px",
    borderRadius: "100px",
    textTransform: "none",
    fontSize: "16px",
    fontFamily: "'Lato', sans-serif !important",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#4A2A1A"
    }
  }
});

function NavBar(props) {
  const { classes } = props;

  // Define your button info here
  const menuItems = [
    {
      name: "Try Wolfe",
      link: "https://www.hellowolfe.ai"
    }
  ];

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {/* LEFT: Brand */}
          <Typography
            variant="h4"
            className={classes.brandText}
            component="a"                       // Makes the <Typography> act as a clickable link. inserting link in the wolfe logo,to return home//This will make "Wolfe" a clickable brand name leading to your website while keeping the same typography style. 🚀
            href="https://hellowolfe.com"       // the link to the home page
            // target="_blank"                     //Opens the link in a new tab.
            // rel="noopener noreferrer"           // Ensures security by preventing the new page from accessing the original page's window object.
            style={{ textDecoration: "none" }} // Removes underline from the link//Ensures the link doesn’t get underlined.
            display="inline"
            color="secondary"
          >
            Wolfe
          </Typography>

          {/* RIGHT: Always show "Try Wolfe" button on all screen sizes */}
          <div>
            {menuItems.map((element) => (
              <a
                key={element.name}
                href={element.link}
                className={classes.noDecoration}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  className={classes.tryWolfeButton}
                  size="large"
                >
                  {element.name}
                </Button>
              </a>
            ))}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(memo(NavBar));

